import * as React from "react";

function SvgLock(props) {
  return <svg width={12} height={16} viewBox="0 0 12 16" fill="none" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M11 7H10V4C10 1.791 8.209 0 6 0C3.791 0 2 1.791 2 4V7H1C0.4475 7 0 7.4475 0 8V15C0 15.5525 0.4475 16 1 16H11C11.5525 16 12 15.5525 12 15V8C12 7.4475 11.5525 7 11 7ZM4 4C4 2.8955 4.8955 2 6 2C7.1045 2 8 2.8955 8 4V7H4V4Z" fill="currentColor" /></svg>;
}

export default "//cdn.scentbird.com/assets/frontbird-site/images/lock_d0d5a2.svg";
export { SvgLock as ReactComponent };